import styled from 'styled-components'

import { CurrencyInformationSocial } from '@root/entities/currency/ui'
import { Skeleton, Separator } from '@root/shared/ui-kit'

import {
  CurrencyCardRoot,
  CurrencyCardTop,
  CurrencyCardTopInfo,
  NameWithBoosters,
  DetailedCurrencyInfo,
  DetailedCurrencyInfoSide,
  Name,
  Ticker,
  TickerValue,
} from './currency-card'
import { Footer, RightColumnFoorter, Socials } from './currency-card-compact'
import { MarketCap } from './market-cap'

export const CurrencyCardCompactSkeleton = () => (
  <CurrencyCardRoot>
    <CurrencyCardTop>
      <Skeleton height={70} width={70} variant="circular" />
      <CurrencyCardTopInfo>
        <NameWithBoosters>
          <Name $premium={false}>
            <Skeleton.Line uppercase width={140} />{' '}
            <Skeleton.Line uppercase width={54} />
          </Name>
        </NameWithBoosters>
        <DetailedCurrencyInfo>
          <DetailedCurrencyInfoSide>
            <Ticker>
              <Skeleton.Line width={36} />
              <TickerValue>
                <Skeleton.Line uppercase width={'3ch'} />
              </TickerValue>
            </Ticker>
            <Ticker>
              <Skeleton.Line width={36} />
              <TickerValue>
                <Skeleton.Line width={80} />
              </TickerValue>
            </Ticker>
            <Ticker>
              <Skeleton.Line width={86} />
            </Ticker>
          </DetailedCurrencyInfoSide>
          <DetailedCurrencyInfoSide>
            <ChartBuyButton>
              <Skeleton.Surface />
            </ChartBuyButton>
            <RightColumnFoorter>
              <MarketCap.Skeleton variant="short" />
            </RightColumnFoorter>
          </DetailedCurrencyInfoSide>
        </DetailedCurrencyInfo>
      </CurrencyCardTopInfo>
    </CurrencyCardTop>

    <Separator />
    <Footer>
      <Socials>
        <CurrencyInformationSocial.Skeleton />
      </Socials>

      <Skeleton.Line width={150} />
    </Footer>
  </CurrencyCardRoot>
)

const ChartBuyButton = styled.div`
  display: block;
  position: relative;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  grid-row: span 2;
`
